// =============================================================================
// Al Rashid Perfumes - Mobile & Desktop Search Enhancement
// =============================================================================
(function() {
  function initSearchEnhancements() {
    // 1. Mobile Search Form Enter & Submit Handler
    var mobileSearchInput = document.getElementById('Search-In-Modal-Sidebar');
    if (mobileSearchInput) {
      mobileSearchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var query = this.value.trim();
          if (query.length > 0) {
            window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          }
        }
      });
    }

    var mobileSearchForm = document.querySelector('#search-form-mobile form');
    if (mobileSearchForm) {
      mobileSearchForm.addEventListener('submit', function(e) {
        var input = this.querySelector('input[name="q"]');
        var query = input ? input.value.trim() : '';
        if (query.length > 0) {
          e.preventDefault();
          window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        }
      });
    }

    // 2. Desktop Search Form Enter & Submit Handler
    var desktopSearchInput = document.getElementById('Search-In-Modal-Basic');
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var query = this.value.trim();
          if (query.length > 0) {
            window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchEnhancements);
  } else {
    initSearchEnhancements();
  }
})();
